import React, { useId, useState } from "react";

export const TERMS_URL = "https://my-stylist.pro/terms";
export const PRIVACY_URL = "https://my-stylist.pro/privacy";

function LegalLink({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-inherit no-underline"
    >
      {children}
    </a>
  );
}

function LegalLinks({ showPrivacyLink }) {
  if (!showPrivacyLink) {
    return <LegalLink href={TERMS_URL}>Terms of Service</LegalLink>;
  }

  return (
    <>
      <LegalLink href={TERMS_URL}>Terms of Service</LegalLink>,{" "}
      <LegalLink href={PRIVACY_URL}>Privacy Policy</LegalLink>
    </>
  );
}

function TrialText({ emphasize }) {
  if (emphasize) {
    return <strong>7-day trial</strong>;
  }

  return <>7-day trial</>;
}

function PriceText({ price, billingPeriod, emphasize }) {
  const text = `${price} ${billingPeriod}`;

  if (emphasize) {
    return <strong>{text}</strong>;
  }

  return <>{text}</>;
}

function DisclaimerCopy({
  price,
  billingPeriod,
  showPrivacyLink,
  emphasize = false,
}) {
  return (
    <>
      By continue, you confirm that you have read and agree to myStylist PRO{" "}
      <LegalLinks showPrivacyLink={showPrivacyLink} />
      {showPrivacyLink ? ", and you undertake" : " and undertake"} to comply
      with these terms. You understand and agree that after the{" "}
      <TrialText emphasize={emphasize} /> period ends, myStylist PRO will
      automatically continue your membership and charge{" "}
      <PriceText
        price={price}
        billingPeriod={billingPeriod}
        emphasize={emphasize}
      />{" "}
      until you cancel it online in the personal account or by email.
    </>
  );
}

function SubscriptionDisclaimer({
  price,
  billingPeriod = "every 3 months",
  className,
  organicClassName,
  isOrganicOrSeo = false,
  showPrivacyLink = true,
}) {
  const labelId = useId();
  const [isChecked, setIsChecked] = useState(true);

  if (isOrganicOrSeo) {
    return (
      <div
        className={
          organicClassName ||
          "flex items-start gap-2 text-[#111827] text-sm leading-relaxed text-left"
        }
      >
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(event) => setIsChecked(event.target.checked)}
          aria-labelledby={labelId}
          className="mt-0.5 h-4 w-4 shrink-0"
        />
        <p id={labelId} className="m-0">
          <DisclaimerCopy
            price={price}
            billingPeriod={billingPeriod}
            showPrivacyLink={showPrivacyLink}
            emphasize
          />
        </p>
      </div>
    );
  }

  return (
    <p className={className}>
      <DisclaimerCopy
        price={price}
        billingPeriod={billingPeriod}
        showPrivacyLink={showPrivacyLink}
      />
    </p>
  );
}

export default SubscriptionDisclaimer;
